import { useEffect, useState } from 'react';
import { signatures } from '../lib/api';

// <img> for private /api/files/* URLs: fetches with the login token and shows a blob URL.
export default function AuthImg({ src, ...props }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let obj = null;
    let alive = true;
    if (src) signatures.fileBlob(src).then((b) => { if (alive) { obj = URL.createObjectURL(b); setUrl(obj); } }).catch(() => {});
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [src]);
  if (!url) return <span className={`inline-block bg-muted animate-pulse ${props.className || ''}`} style={{ width: 96, height: 72 }}/>;
  return <img src={url} alt={props.alt || ''} {...props}/>;
}
